const dev = {
  API_ENDPOINT_URL: "https://api-dev.bignovalearning.com/api",
  IMAGE_URL: "https://api-dev.bignovalearning.com",
  PUBLIC_BLOG_BASE_URL: "https://dev.bignovalearning.com/en/blogs",
  REACT_APP_VAPID_PUBLIC_KEY:
    "BLmbJB0GY8yPaBHF9oYLoxUikatFpo0Idm0rzjjRf2jwuvQ02Klbg8Ke3kX4SRq66Es05YUxDTA9c6jKXQg3smI",
  PUBLIC_CLIENT_URL: "https://dev.bignovalearning.com",
}

// const dev = {
//    API_ENDPOINT_URL: "http://localhost:3030/api",
//    IMAGE_URL: "http://localhost:3030",
//    PUBLIC_BLOG_BASE_URL: "http://localhost:3030/en/blogs",
//    REACT_APP_VAPID_PUBLIC_KEY:
//      "BLmbJB0GY8yPaBHF9oYLoxUikatFpo0Idm0rzjjRf2jwuvQ02Klbg8Ke3kX4SRq66Es05YUxDTA9c6jKXQg3smI",
//   PUBLIC_CLIENT_URL: "http://localhost:4000",
// };

const prod = {
  API_ENDPOINT_URL: "https://api.bignovalearning.com/api",
  IMAGE_URL: "https://api.bignovalearning.com",
  PUBLIC_BLOG_BASE_URL: "https://bignovalearning.com/en/blogs",
  REACT_APP_VAPID_PUBLIC_KEY:
    "BLmbJB0GY8yPaBHF9oYLoxUikatFpo0Idm0rzjjRf2jwuvQ02Klbg8Ke3kX4SRq66Es05YUxDTA9c6jKXQg3smI",
  PUBLIC_CLIENT_URL: "https://bignovalearning.com",
}

const test = {
  API_ENDPOINT_URL: "/api",
  IMAGE_URL: "",
  PUBLIC_BLOG_BASE_URL: "",
  REACT_APP_VAPID_PUBLIC_KEY: "",
}

const getEnv = () => {
  switch (process.env.REACT_APP_STAGE) {
    case "development":
      return dev
    case "production":
      return prod
    case "test":
      return test
    default:
      return dev
  }
}

export const env = getEnv()
